import { decamelizeKeys } from "humps";
import Api from "./api.service";

class Purchases {
  static getAll(tenantSlug, params) {
    const requestParams = decamelizeKeys(params);
    requestParams.include = "owner,assignee,product,product_price";
    return Api.get(`/api/v1/tenants/${tenantSlug}/purchases`, { params: requestParams });
  }

  static get(id, tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/purchases/${id}`, {
      params: { include: "assignee,owner,product,product_price" }
    });
  }

  static getNextPage(tenantSlug, page, filters) {
    const params = decamelizeKeys(filters);
    return Api.get(`/api/v1/tenants/${tenantSlug}/purchases`, {
      params: {
        include: "assignee,owner,product,product_price",
        page: { number: page },
        ...params
      }
    });
  }

  static create(tenantSlug, purchaseAttributes) {
    const relationships = this.relationshipsForRequest(purchaseAttributes);
    const { startDate, endDate } = purchaseAttributes;
    const payload = {
      data: {
        type: "purchases",
        attributes: {
          start_date: startDate,
          end_date: endDate
        },
        relationships
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/purchases`, payload);
  }

  static update(id, tenantSlug, purchaseAttributes) {
    const relationships = this.relationshipsForRequest(purchaseAttributes);
    const { startDate, endDate } = purchaseAttributes;
    const payload = {
      data: {
        id,
        type: "purchases",
        attributes: {
          start_date: startDate,
          end_date: endDate
        },
        relationships
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/purchases/${id}`, payload);
  }

  static cancelPurchase(tenantSlug, purchaseSlug) {
    const payload = {
      data: {
        type: "purchases",
        id: purchaseSlug,
        attributes: {
          slug: purchaseSlug
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/purchases/${purchaseSlug}/cancel`, payload);
  }

  static expirePurchase(tenantSlug, purchaseSlug) {
    const payload = {
      data: {
        type: "purchases",
        id: purchaseSlug,
        attributes: {
          slug: purchaseSlug
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/purchases/${purchaseSlug}/expire_purchase`, payload);
  }

  static renewPurchase(tenantSlug, purchaseSlug) {
    const payload = {
      data: {
        type: "purchases",
        id: purchaseSlug,
        by: "renewal_cron",
        attributes: {
          slug: purchaseSlug
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/purchases/${purchaseSlug}/renew`, payload);
  }

  static renewPurchaseToggle(tenantSlug, purchaseSlug) {
    const payload = {
      data: {
        type: "purchases",
        id: purchaseSlug,
        attributes: {
          slug: purchaseSlug,
          end_date: null
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/purchases/${purchaseSlug}`, payload);
  }

  static relationshipsForRequest(purchaseAttributes) {
    const { product, owner, assignee, productPrice } = purchaseAttributes;
    const relationships = {
      owner: {
        data: {
          type: "customers",
          id: owner
        }
      },
      assignee: {
        data: {
          type: "customers",
          id: assignee
        }
      },
      product: {
        data: {
          type: "products",
          id: product
        }
      },
      product_price: {
        data: {
          type: "product_prices",
          id: productPrice
        }
      }
    };
    return relationships;
  }

  static generateExport(tenantSlug) {
    return Api.get(`api/v1/tenants/${tenantSlug}/purchases/export_csv`);
  }
}

const PurchasesService = Object.freeze(Purchases);

export default PurchasesService;
